module.exports = __webpack_public_path__ + "static/img/6198_phase_function_Paper_PointsHejduk_Prediction.fb2c45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6198_phase_function_Paper_PointsHejduk_Prediction.png
// module id = mf3U
// module chunks = 0